import _ from 'lodash';

const updateQuery = (current, update, pages) => {
  // Ignore any path assignments that fall under a page change
  const pageUpdates = _(update)
    .toPairs()
    .filter(
      ([k, v]) => current[k] !== v && (!pages || pages.includes(`${k}.${v}`)),
    )
    .map(([k, v]) => `${k}.${v}`);
  const result = {
    ..._.omitBy(current, (cV, cK) =>
      pageUpdates.some((uV, uK) => cK.startsWith(`${uK}.`)),
    ),
    ...update,
  };

  return result;
};

export default updateQuery;
